module.exports = __webpack_public_path__ + "static/img/Frame41.65d169bf.png";